<template>
    <div v-if="boxStyle === 'full'">
        <router-link :to="{ name: 'ProductDetails', params: { slug: productDetails.slug } }" class="text-reset d-block lh-0 text-center">
            <div class="h-300px" style="overflow: hidden">
                <img :src="productDetails.thumbnail_image" :alt="productDetails.name" @error="imageFallback($event)" class="border" />
            </div>
        </router-link>
    </div>

    <div
        v-else
        :class="[
            boxStyle == 'two' ? 'product-box-two' : boxStyle == 'three' ? 'product-box-three' : boxStyle == 'four' ? 'product-box-four' : 'product-box-one',
        ]"
    >
        <div v-if="isLoading">
            <v-skeleton-loader type="image" :height="boxStyle == 'two' ? '70' : boxStyle == 'three' ? '150' : boxStyle == 'four' ? '130' : '310'" />
        </div>
        <div class="overflow-hidden" v-else>
            <div class="position-relative">
                <div v-if="discount > 0 && boxStyle != 'two'" class="discount-badge">{{ $t('off') }} {{ discount }}%</div>
                <router-link :to="{ name: 'ProductDetails', params: { slug: productDetails.slug } }" class="text-reset d-block lh-0 text-center">
                    <img :src="productDetails.thumbnail_image" :alt="productDetails.name" @error="imageFallback($event)" class="img-fit" />
                </router-link>
            </div>
            <div>
                <div :class="[boxStyle == 'two' ? 'order-2 fs-14 lh-1' : 'fs-16 mb-2']" v-if="productDetails.base_discounted_price > 0">
                    <template v-if="productDetails.base_price > productDetails.base_discounted_price">
                        <del class="opacity-40">{{ format_price(productDetails.base_price) }}</del>
                        <span class="fw-700">{{ format_price(productDetails.base_discounted_price) }}44</span>
                    </template>
                    <template v-else>
                        <span class="fw-700">{{ format_price(productDetails.base_discounted_price) }}33</span>
                    </template>
                </div>
                <h5>
                    <router-link :to="{ name: 'ProductDetails', params: { slug: productDetails.slug } }" class="text-reset">
                        <span>{{ productDetails.name }}</span>
                    </router-link>
                </h5>

                <!-- 리뷰 정보 표시 -->
                <div v-if="productDetails.review_summary" class="review-info mt-2">
                    <v-rating
                        background-color=""
                        empty-icon="las la-star"
                        full-icon="las la-star active"
                        half-icon="las la-star half"
                        hover
                        half-increments
                        readonly
                        size="16"
                        length="5"
                        :value="productDetails.review_summary.average"
                    ></v-rating>
                    <span class="review-text ms-2">
                        {{ (productDetails.review_summary.average || 0).toFixed(1) }}
                        ({{ productDetails.review_summary.total_count }})
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    export default {
        props: {
            isLoading: { type: Boolean, required: true, default: true },
            boxStyle: { type: String, default: 'one' },
            productDetails: { type: Object, required: true, default: {} },
        },
        data: () => ({}),
        computed: {
            ...mapGetters('wishlist', ['isThisWishlisted']),
            ...mapGetters('cart', ['isThisInCart', 'findCartItemByVariationId']),
            discount() {
                return this.discount_percent(this.$props.productDetails.base_price, this.$props.productDetails.base_discounted_price);
            },
        },
        methods: {
            ...mapActions('wishlist', ['addNewWishlist', 'removeFromWishlist']),
            ...mapActions('cart', ['addToCart', 'updateQuantity']),
            ...mapMutations('auth', ['showAddToCartDialog']),
            addCart() {
                if (!this.$props.productDetails.is_variant) {
                    this.addToCart({
                        variation_id: this.$props.productDetails.variations[0].id,
                        qty: this.$props.productDetails.min_qty,
                    });
                }
            },
            updateCart(type, cart_id) {
                this.updateQuantity({
                    type: type,
                    cart_id: cart_id,
                });
            },
        },
    };
</script>
<style lang="scss" scoped>
    h5 {
        margin: 24px 0 0;
        span {
            font-weight: 500;
            font-size: 18px;
            vertical-align: top;
        }
    }

    .review-info {
        display: flex;
        align-items: center;
    }

    .review-text {
        font-size: 14px;
        color: #666;
    }

    .review-info {
        ::v-deep .v-rating button {
            width: 16px !important;
            height: 16px !important;
            margin-right: 2px !important;
        }
    }
</style>

